import axios from 'axios';

export default function (context) {
    context.dispatch('list/get', {
        data: context.getters['form/data'],
        cb: data => {
            context.commit('balance/set', data);
        },
    });
}